import styled from 'styled-components'

export const Logo = styled.img.attrs({
    src: '/images/logo.png'
})`
    cursor: pointer;
`;